// 取引所 ID → UI 表示名の共通ヘルパー
// id がアンダースコア入り (bitget_uta 等) でも見やすくするための変換
const EXCHANGE_DISPLAY_NAMES = {
  bitget_uta: 'Bitget(総合)',
};

export function formatExchangeName(id) {
  if (!id) return '';
  if (EXCHANGE_DISPLAY_NAMES[id]) return EXCHANGE_DISPLAY_NAMES[id];
  // デフォルト: 先頭大文字化 (TradeHistory 等の従来挙動と互換)
  return id.charAt(0).toUpperCase() + id.slice(1);
}

// 全大文字版 (Dashboard 等で `EXCHANGE` のように出してたい場合)
export function formatExchangeNameUpper(id) {
  if (!id) return '';
  if (EXCHANGE_DISPLAY_NAMES[id]) return EXCHANGE_DISPLAY_NAMES[id];
  return id.toUpperCase();
}
